export enum WebhookEvent {
  APPLICATION_STARTUP = "application.startup",
  QRCODE_UPDATED = "qrcode.updated",
  CONNECTION_UPDATE = "connection.update",
  MESSAGES_SET = "messages.set",
  MESSAGES_UPSERT = "messages.upsert",
  MESSAGES_UPDATE = "messages.update",
  MESSAGES_DELETE = "messages.delete",
  SEND_MESSAGE = "send.message",
  CONTACTS_SET = "contacts.set",
  CONTACTS_UPSERT = "contacts.upsert",
  CONTACTS_UPDATE = "contacts.update",
  PRESENCE_UPDATE = "presence.update",
  CHATS_SET = "chats.set",
  CHATS_UPDATE = "chats.update",
  CHATS_UPSERT = "chats.upsert",
  CHATS_DELETE = "chats.delete",
  GROUPS_UPSERT = "groups.upsert",
  GROUPS_UPDATE = "groups.update",
  GROUP_PARTICIPANTS_UPDATE = "group.participants.update",
  NEW_TOKEN = "new.jwt",
}

export enum WebhookEventSetup {
  APPLICATION_STARTUP = "APPLICATION_STARTUP",
  QRCODE_UPDATED = "QRCODE_UPDATED",
  CONNECTION_UPDATE = "CONNECTION_UPDATE",
  MESSAGES_SET = "MESSAGES_SET",
  MESSAGES_UPSERT = "MESSAGES_UPSERT",
  MESSAGES_UPDATE = "MESSAGES_UPDATE",
  MESSAGES_DELETE = "MESSAGES_DELETE",
  SEND_MESSAGE = "SEND_MESSAGE",
  CONTACTS_SET = "CONTACTS_SET",
  CONTACTS_UPSERT = "CONTACTS_UPSERT",
  CONTACTS_UPDATE = "CONTACTS_UPDATE",
  PRESENCE_UPDATE = "PRESENCE_UPDATE",
  CHATS_SET = "CHATS_SET",
  CHATS_UPDATE = "CHATS_UPDATE",
  CHATS_UPSERT = "CHATS_UPSERT",
  CHATS_DELETE = "CHATS_DELETE",
  GROUPS_UPSERT = "GROUPS_UPSERT",
  GROUPS_UPDATE = "GROUPS_UPDATE",
  GROUP_PARTICIPANTS_UPDATE = "GROUP_PARTICIPANTS_UPDATE",
  NEW_TOKEN = "NEW_TOKEN",
  MESSAGES_EDITED = "MESSAGES_EDITED",
  LABELS_EDIT = "LABELS_EDIT",
  LABELS_ASSOCIATION = "LABELS_ASSOCIATION",
  CALL = "CALL",
  TYPEBOT_START = "TYPEBOT_START",
  TYPEBOT_CHANGE_STATUS = "TYPEBOT_CHANGE_STATUS",
  ERRORS = "ERRORS",
  ERRORS_WEBHOOK = "ERRORS_WEBHOOK",
}
